// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__8bcpt","inner":"Login_inner__+cKfU"};